function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#124462",
    d: "M 25.5,7.5 C 29.5138,7.33449 33.5138,7.50115 37.5,8C 39.0368,9.10963 39.7035,10.6096 39.5,12.5C 43.5,12.5 47.5,12.5 51.5,12.5C 51.5,13.8333 51.5,15.1667 51.5,16.5C 50.5,16.5 49.5,16.5 48.5,16.5C 47.6135,28.8566 46.4469,41.19 45,53.5C 44.5,54 44,54.5 43.5,55C 35.5,55.6667 27.5,55.6667 19.5,55C 19,54.5 18.5,54 18,53.5C 16.5531,41.19 15.3865,28.8566 14.5,16.5C 13.5,16.5 12.5,16.5 11.5,16.5C 11.5,15.1667 11.5,13.8333 11.5,12.5C 15.5,12.5 19.5,12.5 23.5,12.5C 23.3915,10.4862 24.0582,8.81953 25.5,7.5 Z M 28.5,10.5 C 31.0728,10.1485 33.4062,10.6485 35.5,12C 32.8333,12.6667 30.1667,12.6667 27.5,12C 28.056,11.6174 28.3893,11.1174 28.5,10.5 Z M 18.5,16.5 C 27.1667,16.5 35.8333,16.5 44.5,16.5C 43.4492,28.1595 42.4492,39.8262 41.5,51.5C 34.8333,51.5 28.1667,51.5 21.5,51.5C 20.5508,39.8262 19.5508,28.1595 18.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.751
    },
    fill: "#124562",
    d: "M 23.5,21.5 C 24.8333,21.5 26.1667,21.5 27.5,21.5C 27.5,29.8333 27.5,38.1667 27.5,46.5C 26.1667,46.5 24.8333,46.5 23.5,46.5C 23.5,38.1667 23.5,29.8333 23.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.751
    },
    fill: "#124562",
    d: "M 29.5,21.5 C 30.8333,21.5 32.1667,21.5 33.5,21.5C 33.5,29.8333 33.5,38.1667 33.5,46.5C 32.1667,46.5 30.8333,46.5 29.5,46.5C 29.5,38.1667 29.5,29.8333 29.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.751
    },
    fill: "#124562",
    d: "M 35.5,21.5 C 36.8333,21.5 38.1667,21.5 39.5,21.5C 39.5,29.8333 39.5,38.1667 39.5,46.5C 38.1667,46.5 36.8333,46.5 35.5,46.5C 35.5,38.1667 35.5,29.8333 35.5,21.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.6da0ce7a17985eebe89e4900655978c1.svg";
export { ForwardRef as ReactComponent };